// extracted by mini-css-extract-plugin
export default {"reviewQuote":"styles_reviewQuote__VVviC","reviewQuote__quote":"styles_reviewQuote__quote__4Cy34","reviewQuote__name":"styles_reviewQuote__name__Gv0EV"};